var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0"},[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"7"}},[_c('div',{staticClass:"darker"},[_vm._v(_vm._s(_vm.text))])]),_c('v-col',{staticClass:"text-center",attrs:{"cols":"2"}},[_c('span')])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }